import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    // null = checking, false = signed out, object = signed-in user (may be pending)
    const [admin, setAdmin] = useState(null);

    const checkAuth = useCallback(() => {
        api
            .get("/auth/me")
            .then((r) => setAdmin(r.data))
            .catch(() => setAdmin(false));
    }, []);

    useEffect(() => {
        // If returning from the Google OAuth callback, let AuthCallback exchange
        // the session_id first; skip the /me check to avoid a race.
        if (window.location.hash?.includes("session_id=")) return;
        checkAuth();
    }, [checkAuth]);

    const logout = async () => {
        try {
            await api.post("/auth/logout");
        } catch {
            /* ignore network errors on logout */
        }
        setAdmin(false);
    };

    return (
        <AuthContext.Provider value={{ admin, setAdmin, logout, refresh: checkAuth }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    return useContext(AuthContext);
}
